<prism-select 
  [selectOptions]="options"
  [label]="selected.label"
  placeHolder="Select a Course"
  [control]="selected.control"
  [required]="selected.required"
  [readOnly]="selected.readOnly"
  [allowDeselect]="true"
  [labelClass]="selected.labelClass"
  (onSelected)="emitCourse($event)">
</prism-select>
